import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-contract-form-minor-disabled-person',
    templateUrl: './contract-form-minor-disabled-person.component.html',
    styleUrls: ['./contract-form-minor-disabled-person.component.scss'],
})
export class ContractFormMinorDisabledPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    client: Client;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
